<template>
<modal ref="modal" body-class="px-2 px-lg-5 pb-lg-5">
    <h5 class="mb-4">Please complete the bank account details for your payout to be sent to.</h5>
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label for="holderName">Name of account holder</label>
                <input type="text" id="holderName" v-model.trim="$v.accountName.$model"
                       class="form-control form-control-lg" :class="{'is-invalid' : $v.accountName.$error}">
                <div class="invalid-feedback" v-if="!$v.accountName.required">
                    Please enter account holder name
                </div>
            </div>
            <div class="form-group">
                <label for="accountNumber">Bank/Building Society account number</label>
                <input type="text" id="accountNumber"  v-model.trim="$v.accountNumber.$model"
                       class="form-control form-control-lg" :class="{'is-invalid' : $v.accountNumber.$error}">
                <div class="invalid-feedback" v-if="!$v.accountNumber.required">
                    Please enter account number
                </div>
                <div class="invalid-feedback " v-if="(!$v.accountNumber.minLength || !$v.accountNumber.maxLength)">
                    Account number should be between 6 and 8 digits
                </div>
                <div class="invalid-feedback " v-if="!$v.accountNumber.numeric">
                    Account number should be numeric
                </div>
            </div>
            <div class="form-group">
                <label for="branchCode1">Branch sort code</label>
                <div class="d-flex justify-content-center align-items-center w-100"  :class="{'is-invalid' : $v.bankSortCode.$error}">
                    <input type="text" id="branchCode1" ref="branchCodeSegmentFirst" v-model.trim="$v.bankSortCodeFirst.$model"
                           class="branch-code-segment form-control form-control-lg flex-fill w-25" :class="{'is-invalid' : $v.bankSortCodeFirst.$error}"
                           maxlength="2" @input="handleFirstBranchSegment">
                    <span class="mx-2">-</span>
                    <input type="text" id="branchCode2" ref="branchCodeSegmentSecond"  v-model.trim="$v.bankSortCodeSecond.$model"
                           class="branch-code-segment form-control form-control-lg flex-fill w-25" :class="{'is-invalid' : $v.bankSortCodeSecond.$error}"
                           maxlength="2" @input="handleSecondBranchSegment">
                    <span class="mx-2">-</span>
                    <input type="text" id="branchCode3" ref="branchCodeSegmentThird" v-model.trim="$v.bankSortCodeThird.$model"
                           class="branch-code-segment form-control form-control-lg flex-fill w-25" :class="{'is-invalid' : $v.bankSortCodeThird.$error}"
                           maxlength="2" @input="handleThirdBranchSegment">
            
                </div>
                <div class="invalid-feedback " v-if="(!$v.bankSortCode.minLength || !$v.bankSortCode.maxLength)">
                    Bank sort code should be exactly 6 digits
                </div>
                <div class="invalid-feedback " v-if="!$v.bankSortCode.numeric">
                    Bank sort code should be numeric
                </div>
            </div>
            <div class="form-group">
                <label for="accountAddress">Account Address</label>
                <input type="text" id="accountAddress" v-model.trim="$v.accountAddress.$model"
                       class="form-control form-control-lg" :class="{'is-invalid' : $v.accountAddress.$error}">
                <div class="invalid-feedback" v-if="!$v.accountAddress.required">
                    Please enter account address
                </div>
            </div>
            <div class="text-danger text-center p-3" v-if="errorBalanceLow">
                Your balance needs to be at least &pound;{{globalMinimalPayout}}, before you can request a payout.
            </div>
            <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                <button class="btn btn-lg btn-outline-info px-5 btn-block mt-2 mr-sm-3" @click="hide">Cancel</button>
                <button class="btn btn-lg btn-success btn-success-gradient px-5 btn-block mt-2 " @click="request">Request</button>
            </div>
        </div>
    </div>
</modal>
</template>

<script>
import Modal from "@/components/Modal";
import {validationMixin} from 'vuelidate'
import {maxLength, minLength, numeric, required} from 'vuelidate/lib/validators'
import {EventBus, events} from "@/utils/event-bus";
import api from "@/utils/api";
import RewardHelper from "@/mixins/RewardHelper";

export default {
name: "RequestPayoutModal",
    mixins: [validationMixin, RewardHelper],
    components: {Modal},
    methods: {
        request: function (){
            let that = this;
            this.errorBalanceLow = false;
            if(this.$store.getters['auth/totalBalance'] < this.globalMinimalPayout){
                this.errorBalanceLow = true;
                return;
            }
            
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
    
            api.withdraw({
                accountName: this.accountName,
                accountNumber: this.accountNumber,
                bankSortCode: this.bankSortCode,
                accountAddress: this.accountAddress,
            }).then(() => {
                EventBus.$emit(events.rewards.payout)
                that.hide()
                that.$toast.success("Payout Request sent!");
            }).catch(err => {
                if (err.response.data.error.code === 20505) {
                    that.errorBalanceLow = true;
                }
            })
        },
        show() {
            this.$refs.modal.show();
        },
        hide() {
            this.$refs.modal.hide();
        },
        handleFirstBranchSegment(e) {
            if(e.target.value.length === 2){
                this.$refs.branchCodeSegmentSecond.focus()
            }
        },
        // eslint-disable-next-line no-unused-vars
        handleSecondBranchSegment(e) {
            if(e.target.value.length === 2){
                this.$refs.branchCodeSegmentThird.focus()
            }
            if(e.target.value.length === 0){
                this.$refs.branchCodeSegmentFirst.focus()
            }
        },
        // eslint-disable-next-line no-unused-vars
        handleThirdBranchSegment(e) {
            if(e.target.value.length === 0){
                this.$refs.branchCodeSegmentSecond.focus()
            }
        },
    },
    data() {
        return {
            accountName: null,
            accountNumber: null,
            bankSortCodeFirst: null,
            bankSortCodeSecond: null,
            bankSortCodeThird: null,
            accountAddress: null,
            errorBalanceLow: false,
        }
    },
    validations: function () {
        return {
            accountName: {
                required
            },
            accountAddress: {
                required
            },
            accountNumber: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(8),
                numeric
            },
            bankSortCodeFirst: {
                required
            },
            bankSortCodeSecond: {
                required
            },
            bankSortCodeThird: {
                required
            },
            bankSortCode: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(6),
                numeric
            }
        }
    },
    computed: {
        bankSortCode() {
            return `${this.bankSortCodeFirst}${this.bankSortCodeSecond}${this.bankSortCodeThird}`;
        }
    },
}

</script>

<style scoped>
.branch-code-segment {
    text-align: center;
}
</style>
